import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { getTheme } from '@its/components/lib/util/preferences';
import { getThemeByName } from '@its/components/lib/style/themes';

export default getMuiTheme(getThemeByName(getTheme() || 'green'));



/** WEBPACK FOOTER **
 ** ./src/theme.js
 **/